<template>
  <base-dialog
    :title="'house.param.livingFloor.title' | i18n"
    :subtitle="'house.param.livingFloor.subtitle' | i18n"
    :description="'house.param.livingFloor.description' | i18n">

    <div class="container-fluid" style="padding: 0;">
      <div class="row">
        <div class="col-4">
          <img src="../../assets/param/common_area.png" />
        </div>

        <div class="col-8">
          <label>Pinta-ala (huoneala 30,0 - 200,0 m2)</label>
          <input-number v-model="livingFloorArea" :decimals="1" :min="30.0" :max="200.0" />
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <img src="../../assets/param/house_living_floor.png" />
        </div>

        <div class="col-8">
          <label>Huoneiden lukumäärä (1-9 huonetta)</label>
          <select v-model="livingFloorNumOfRooms" class="form-control">
            <option :value="1">1 huone</option>
            <option v-for="n in 8" :value="1 + n">{{ 1 + n }} huonetta</option>
          </select>
        </div>
      </div>
    </div>
  </base-dialog>
</template>


<script>
  import BaseDialog from "./BaseDialog"

  export default {
    computed: {
      livingFloorNumOfRooms: {
        get() {
          return this.$store.state.houseParams.livingFloorNumOfRooms
        },
        set(livingFloorNumOfRooms) {
          this.$store.commit('houseParams/SET_LIVING_FLOOR_NUM_OF_ROOMS', livingFloorNumOfRooms)
        }
      },
      livingFloorArea: {
        get() {
          return this.$store.state.houseParams.livingFloorArea
        },
        set(livingFloorArea) {
          this.$store.commit('houseParams/SET_LIVING_FLOOR_AREA', livingFloorArea)
        }
      }
    },

    created() {
      if(this.livingFloorNumOfRooms == null) {
        this.livingFloorNumOfRooms = 1
      }
      if(this.livingFloorArea == null) {
        this.livingFloorArea = 30.0
      }
    },

    components: {
      BaseDialog
    }
  }
</script>

<style scoped>
  img {
    width: 100%;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/HouseLivingFloorDialog.vue